import React from 'react'
import { LoadingStyle } from './LoadingStyle'

const Loading = () => {
  return (
    <LoadingStyle />
  )
}

export default Loading
